import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { AuthTokenResponse } from './type';

// Singleton to prevent multiple simultaneous refresh token calls
let ongoingRefreshPromise: Promise<AuthTokenResponse> | null = null;

export const requireRefreshedToken = async (refreshToken: string) => {
  // If there's already a refresh in progress, return that promise
  if (ongoingRefreshPromise) {
    return ongoingRefreshPromise;
  }

  const url = `${import.meta.env.VITE_AUTH_SERVICE_HOST}/v1/refresh-token`;

  // Create new refresh promise
  ongoingRefreshPromise = request({ url, method: RequestMethod.POST, body: { refreshToken } })
    .then((response: AuthTokenResponse) => {
      ongoingRefreshPromise = null; // Clear the promise on success
      return response;
    })
    .catch((error) => {
      ongoingRefreshPromise = null; // Clear the promise on error
      throw error;
    });

  return ongoingRefreshPromise;
};
